import React from 'react';
import {Grid} from 'semantic-ui-react';

import {columns} from '@modules/events/components/Table/EventContentMultiAudio/EventContentMultiAudioTable';

export const TableHeader = () => {
    return <Grid className='editableTable__header --audio_header'>
        <Grid.Row>
            {Object.keys(columns).map(key => (
                <Grid.Column key={key} width={columns[key].width}>{columns[key].label}</Grid.Column>
            ))}
        </Grid.Row>
    </Grid>;
};
